import { useEffect, useState } from "react";
import { decodeUrl } from "../../helperFunctions";
import { useAppSelector } from "../../redux/hooks";

export const ProfilePicture = ({
  className,
  tempSrc,
}: {
  className?: string;
  tempSrc?: string;
}) => {
  const [profileBgColor, setProfileBgColor] = useState("");
  const [image, setImage] = useState<string>();

  const profile = useAppSelector((state) => {
    return state.auth.profile;
  });

  useEffect(() => {
    const colors = ["!bg-[#F1D7FD] !border-[#F1D7FD]"];
    const random = Math.floor(Math.random() * colors.length);
    setProfileBgColor(colors[random]);
  }, []);

  useEffect(() => {
    if (profile?.type === "cooperative") {
      setImage(profile?.logo || "/assets/images/profile.svg");
    } else {
      setImage(profile?.Picture || "/assets/images/profile.svg");
    }
  }, [profile]);

  return (
    <div
      className={`
        relative w-[32px] h-[32px] min-w-[32px]
        border border-light-grey
        rounded-full ${!image && !tempSrc && profileBgColor}
        text-pry-dark-green-400 text-xs text-center font-medium uppercase
        flex items-center justify-center
        ${className}
        `}
    >
      {image || tempSrc ? (
        <img
          src={tempSrc ? tempSrc : decodeUrl(image)}
          alt="profile"
          className="w-full h-full object-cover rounded-full"
        />
      ) : (
        <>
          {profile?.type === "member"
            ? `${profile?.FirstName?.slice(0, 1)}${profile?.LastName?.slice(
                0,
                1
              )}`
            : profile?.CoopName?.slice(0, 1)}
        </>
      )}
    </div>
  );
};
